import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = { class: "card" }
const _hoisted_2 = { class: "card-header" }
const _hoisted_3 = { class: "card-title" }
const _hoisted_4 = { class: "card-body py-4" }
const _hoisted_5 = {
  class: "table align-middle table-row-dashed fs-6 gy-5",
  id: "table_accounts_requests"
}
const _hoisted_6 = { class: "text-start text-muted fw-bold fs-7 text-uppercase gs-0" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("th", null, "Party ID", -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("th", null, "Tenant ID", -1)
const _hoisted_9 = { class: "text-center" }
const _hoisted_10 = { key: 0 }
const _hoisted_11 = { key: 1 }
const _hoisted_12 = {
  key: 2,
  class: "fw-semibold text-gray-900"
}
const _hoisted_13 = { class: "" }
const _hoisted_14 = { class: "text-center" }
const _hoisted_15 = ["onClick"]

import { onMounted, ref } from "vue";
import TableFooter from "@/components/TableFooter.vue";
import UserDetails from "../../../components/UserDetails.vue";
import TimeShow from "@/components/TimeShow.vue";
import LoadingRing from "@/components/LoadingRing.vue";
import NoDataBox from "@/components/NoDataBox.vue";
import UserService from "../services/UserService";


export default /*#__PURE__*/_defineComponent({
  __name: 'AllUsers',
  setup(__props) {

const tenantId = ref(parseInt(window.localStorage.getItem("tenant"), 10));
const userShow = ref<InstanceType<typeof UserDetails>>();
const users = ref(Array<any>());
const isLoading = ref(true);

const criteria = ref<any>({
  page: 1,
  size: 20,
});

onMounted(() => {
  fetchUsers(1);
});

const fetchUsers = async (_page?: number) => {
  isLoading.value = true;
  if (_page) criteria.value.page = _page;
  try {
    const results = await UserService.fetchAllUsers(criteria.value);
    users.value = results.data;
    criteria.value = results.criteria;
  } catch (error) {
    console.error(error);
  }
  isLoading.value = false;
};

const switchTenant = async (item: any) => {
  isLoading.value = true;
  try {
    await UserService.switchTenant(item.partyId, item.tenantId, tenantId.value);
    fetchUsers(1);
  } catch (error) {
    console.error(error);
    fetchUsers(1);
  } finally {
    isLoading.value = false;
  }
};

const reset = () => {
  criteria.value = {
    page: 1,
    size: 20,
  };
  fetchUsers(1);
};

const showDetail = async (partyId: number) => {
  userShow.value?.show(partyId);
};

return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_UserInfo = _resolveComponent("UserInfo")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_component_el_input, {
            modelValue: criteria.value.email,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((criteria.value.email) = $event)),
            class: "w-300px",
            placeholder: _ctx.$t('fields.searchByEmail'),
            clearable: ""
          }, null, 8, ["modelValue", "placeholder"]),
          _createVNode(_component_el_button, {
            class: "ms-2",
            type: "primary",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (fetchUsers(1)))
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t("action.search")), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_el_button, {
            onClick: _cache[2] || (_cache[2] = ($event: any) => (reset()))
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t("action.reset")), 1)
            ]),
            _: 1
          })
        ])
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("table", _hoisted_5, [
          _createElementVNode("thead", null, [
            _createElementVNode("tr", _hoisted_6, [
              _hoisted_7,
              _createElementVNode("th", null, _toDisplayString(_ctx.$t("fields.user")), 1),
              _hoisted_8,
              _createElementVNode("th", _hoisted_9, _toDisplayString(_ctx.$t("fields.emailConfirmed")), 1),
              _createElementVNode("th", null, _toDisplayString(_ctx.$t("fields.phoneNum")), 1),
              _createElementVNode("th", null, _toDisplayString(_ctx.$t("fields.country")), 1),
              _createElementVNode("th", null, _toDisplayString(_ctx.$t("fields.language")), 1),
              _createElementVNode("th", null, _toDisplayString(_ctx.$t("fields.updatedOn")), 1),
              _createElementVNode("th", null, _toDisplayString(_ctx.$t("fields.createdOn")), 1),
              _createElementVNode("th", null, _toDisplayString(_ctx.$t("action.action")), 1)
            ])
          ]),
          (isLoading.value)
            ? (_openBlock(), _createElementBlock("tbody", _hoisted_10, [
                _createVNode(LoadingRing)
              ]))
            : (!isLoading.value && users.value.length === 0)
              ? (_openBlock(), _createElementBlock("tbody", _hoisted_11, [
                  _createVNode(NoDataBox)
                ]))
              : (_openBlock(), _createElementBlock("tbody", _hoisted_12, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(users.value, (item, index) => {
                    return (_openBlock(), _createElementBlock("tr", { key: index }, [
                      _createElementVNode("th", null, _toDisplayString(item.partyId) + " (" + _toDisplayString(item.id) + ") ", 1),
                      _createElementVNode("td", _hoisted_13, [
                        (item.tenantId == tenantId.value)
                          ? (_openBlock(), _createBlock(_component_UserInfo, {
                              key: 0,
                              url: "#",
                              avatar: item.avatar,
                              title: item.firstName + ' ' + item.lastName,
                              sub: item.email,
                              name: item.firstName + ' ' + item.lastName,
                              user: item,
                              class: "me-2 d-flex align-items-center"
                            }, null, 8, ["avatar", "title", "sub", "name", "user"]))
                          : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                              _createElementVNode("div", null, _toDisplayString(item.firstName + " " + item.lastName), 1),
                              _createElementVNode("div", null, _toDisplayString(item.email), 1)
                            ], 64))
                      ]),
                      _createElementVNode("th", null, _toDisplayString(item.tenantId), 1),
                      _createElementVNode("td", _hoisted_14, [
                        _createElementVNode("i", {
                          class: "fa-solid fa-circle-check fa-lg",
                          style: _normalizeStyle(item.emailConfirmed ? 'color: #5cb85c' : 'color: #gray')
                        }, null, 4)
                      ]),
                      _createElementVNode("td", null, "+" + _toDisplayString(item.ccc) + " " + _toDisplayString(item.phoneNumber), 1),
                      _createElementVNode("td", null, _toDisplayString(item.countryCode), 1),
                      _createElementVNode("td", null, _toDisplayString(item.language), 1),
                      _createElementVNode("td", null, [
                        _createVNode(TimeShow, {
                          "date-iso-string": item.updatedOn
                        }, null, 8, ["date-iso-string"])
                      ]),
                      _createElementVNode("td", null, [
                        _createVNode(TimeShow, {
                          "date-iso-string": item.createdOn
                        }, null, 8, ["date-iso-string"])
                      ]),
                      _createElementVNode("td", null, [
                        (item.tenantId == tenantId.value)
                          ? (_openBlock(), _createElementBlock("button", {
                              key: 0,
                              class: "btn btn-light btn-success btn-sm me-3",
                              onClick: ($event: any) => (showDetail(item.partyId))
                            }, _toDisplayString(_ctx.$t("title.details")), 9, _hoisted_15))
                          : (_openBlock(), _createBlock(_component_el_button, {
                              key: 1,
                              type: "primary",
                              size: "small",
                              onClick: ($event: any) => (switchTenant(item))
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode("Switch Tenant")
                              ]),
                              _: 2
                            }, 1032, ["onClick"]))
                      ])
                    ]))
                  }), 128))
                ]))
        ]),
        _createVNode(TableFooter, {
          onPageChange: fetchUsers,
          criteria: criteria.value
        }, null, 8, ["criteria"])
      ])
    ]),
    _createVNode(UserDetails, {
      ref_key: "userShow",
      ref: userShow
    }, null, 512)
  ], 64))
}
}

})